import { OrganizationStaffRoleType } from '@/shared/api/protocol-ts/model/dto_organization_staff_pb';
import { FormatMessageFunction } from '@/shared/config';

import { i18n } from '../config';

export const getOrganizationDoctorsRoles = (
  roles: OrganizationStaffRoleType[],
  formatMessage: FormatMessageFunction,
) =>
  roles.map((role: OrganizationStaffRoleType) =>
    formatMessage(i18n.permissionOwners[role]),
  );
